import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classes from "./HomePage.module.css";
import { MapContext, NavBarContext } from '../../App';

import TopPage from "../../components/HomePage/TopPage";
// import BottomPage from "../../components/HomePage/BottomPage";

import Funktioniert from "../../components/HomePage/Extras/Funktioniert";
import ImagesCarousel from "../../components/HomePage/Extras/ImagesCarousel";
import BecomeHost from "../../components/HomePage/Extras/BecomeHost";
import FAQSection, { FAQ_SECTION_ID } from "../../components/HomePage/Extras/FAQSection";

import Footer from "../../components/HomePage/Footer";
import BottomFooter from "../../components/BottomFooter.jsx";
import NavBar from '../../components/NavBar/NavBar.jsx';
import NavBarPhone from '../../components/NavBarPhone/NavBarPhone.jsx';
import PopUp from '../../components/RegisterPopUp/PopUp.jsx';
import { useUser } from "../../hooks/useUser";
import UpdatesModal from "../../components/HomePage/UpdatesModal";

const UPDATES_MODAL_SEEN_DATE_KEY = 'stu_updates_modal_last_seen_date';
const UPDATES_MODAL_DISCOVERED_KEY = 'stu_updates_modal_discovered';
const UPDATES_MODAL_EDITOR_ENTERED_KEY = 'stu_updates_modal_editor_entered';

export const HomePage = () => {
  const [showPhoneSearch, setShowPhoneSearch] = useState(false);
  const [showUpdatesModal, setShowUpdatesModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { _id: userId } = useSelector((state) => state.auth.user || {});
  
  const { setHideTopPage } = useContext(MapContext);
  const { setShowSignIn, setShowRegister, isPhoneSize } = useContext(NavBarContext);
  const { userData } = useUser(userId);

  useEffect(() => {
    if (location.hash === `#${FAQ_SECTION_ID}`) {
      const timeoutId = setTimeout(() => {
        const faqSection = document.getElementById(FAQ_SECTION_ID);
        if (!faqSection) return;

        const offset = 100;
        const top = faqSection.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }, 120);
      return () => clearTimeout(timeoutId);
    }

    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    setHideTopPage(false);
  }, []);

  // Check if user was redirected from a protected route and open login modal
  useEffect(() => {
    if (location.state?.requiresAuth) {
      setShowSignIn(true);
      setShowRegister(false);
      
      // Clear the state to prevent reopening on subsequent visits
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [location.state, setShowSignIn, setShowRegister]);

  // Open welcome popup after successful registration redirect
  const shouldShowWelcome = Boolean(location.state?.showWelcome);
  useEffect(() => {
    if (shouldShowWelcome) {
      // Clear the state once we render with the popup
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [shouldShowWelcome]);

  const buildUserScopedKey = (baseKey) => `${baseKey}_${userId || 'guest'}`;

  const openUpdatesModalForToday = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(buildUserScopedKey(UPDATES_MODAL_SEEN_DATE_KEY), today);
    setShowUpdatesModal(true);
  };

  useEffect(() => {
    if (!userId || userData === undefined) {
      return;
    }

    const hasAtLeastOneStudio = Array.isArray(userData?.studios) && userData.studios.length > 0;
    if (!hasAtLeastOneStudio) {
      setShowUpdatesModal(false);
      return;
    }

    const discoveredUpdates = localStorage.getItem(buildUserScopedKey(UPDATES_MODAL_DISCOVERED_KEY)) === 'true';
    const enteredEditor = localStorage.getItem(buildUserScopedKey(UPDATES_MODAL_EDITOR_ENTERED_KEY)) === 'true';

    if (discoveredUpdates || enteredEditor) {
      setShowUpdatesModal(false);
      return;
    }

    const today = new Date().toISOString().slice(0, 10);
    const lastSeenDate = localStorage.getItem(buildUserScopedKey(UPDATES_MODAL_SEEN_DATE_KEY));

    if (lastSeenDate !== today) {
      openUpdatesModalForToday();
    }
  }, [userId, userData]);

  const handleCloseUpdatesModal = () => {
    setShowUpdatesModal(false);
  };

  const handleDiscoverUpdates = () => {
    localStorage.setItem(buildUserScopedKey(UPDATES_MODAL_DISCOVERED_KEY), 'true');
    setShowUpdatesModal(false);

    const firstStudioId = userData?.studios?.[0]?.id;
    if (firstStudioId) {
      navigate(`/services-studios/editor/${firstStudioId}`);
      return;
    }

    navigate('/services-studios');
  };

  return (
      <div
       className={classes.homePage}
      >
        {!isPhoneSize ? (
          <NavBar 
            showSignIn
            showRegister
          />
        ) : (
          <NavBarPhone 
            fromHomePage={true}
            showSignIn
            showRegister
          />
        )}
        <TopPage setShowPhoneSearch={setShowPhoneSearch} />
        {/* <BottomPage /> */}
        <Funktioniert />
        <ImagesCarousel />
        <BecomeHost />
        <FAQSection />
        <Footer />
        <BottomFooter />
        <PopUp initiallyOpen={shouldShowWelcome} />
        <UpdatesModal
          open={showUpdatesModal}
          onClose={handleCloseUpdatesModal}
          onDiscover={handleDiscoverUpdates}
        />
        {/* <StudioErstellen /> */}
      </div>
  );
};

export default HomePage;